import './Subscribe.css';
function Subscribe() {
  return (
    <div className='subscribe-section'>
        <div className='subscribe-section-one'>subscribe</div>
        <div className='subscribe-section-two'>
            <input type='email' placeholder='your email'/>
            <button>subscribe</button>
        </div>
    </div>
  );
}

export default Subscribe;
